import { render } from "./Impayes.vue?vue&type=template&id=7d4e44b6"
import script from "./Impayes.vue?vue&type=script&lang=js"
export * from "./Impayes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__